import { schedularTherapistFilterAction } from 'src/redux/actions/constant';

const initialState: object = {
  response: null,
  data: [],
  fetched: false,
  loading: false,
};

export const getAllMaintainedTherapist = (state = initialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        data: action.payload.data,
        fetched: true,
        loading: false,
      };
    }
    case schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_FAILURE: {
      return {
        ...state,
        response: action.payload,
        fetched: false,
        loading: false,
      };
    }
    case schedularTherapistFilterAction.GET_ALL_MAINTAINED_THERAPISTS_RESET:
      return initialState;

    default:
      return state;
  }
};
